// import React, { useState, useEffect } from "react";
// import { Button, Collapse, Modal } from "react-bootstrap";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import { IMAGEAPI } from "../../BackendConnections";
// import {
//   fetchMyReferencesAction,
//   fetchRequestedReferenceAction,
//   sendReferenceRequestedAction,
//   updateUserReferenceAction,
// } from "../../redux/actions/network/networkAction";
// import HexaImage from "../utils/imgCards/HexaImage";
// import axiosInstance from "../authentication/helper/axiosApi";

// export const References = (props) => {
//   console.log(props);
//   const [refId, setRefId] = useState(null);
//   const [data, setData] = useState({
//     is_myReferences: false,
//     is_requested_references: false,
//   });

//   const [mailSent, setMailSent] = useState(false);
//   const [isRequested, setIsRequested] = useState(false);
//   const [requestedReference, setRequestedReference] = useState([]);
//   const [sendReference, setSendReference] = useState([]);
//   const [requestModel, setRequestModel] = useState(false);
//   const [formData, setFormData] = useState([]);
//   const [myReferences, setMyreferences] = useState();
//   const [shouldRenderMyReferences, setShouldRenderMyReferences] =
//     useState(true);
//   const [showFullText, setShowFullText] = useState([]);
//   const [showRequestFullText, setShowRequestFullText] = useState([]);
//   const toggleText = (index) => {
//     setShowFullText((prev) => {
//       const newShowRequestFullText = [...prev];
//       newShowRequestFullText[index] = !prev[index];
//       return newShowRequestFullText;
//     });
//   };
//   const toggleRequestText = (index) => {
//     setShowRequestFullText((prev) => {
//       const newShowRequestFullText = [...prev];
//       newShowRequestFullText[index] = !prev[index];
//       return newShowRequestFullText;
//     });
//   };

//   //Accept Refrence
//   const handleRequestedReferenceFormChange = (index, row) => {
//     const uniqReferenceId = row?.references.findIndex((row) => {
//       return row.referees_email === props?.user?.email;
//     });
//     setRefId(uniqReferenceId);
//     setRequestModel(true);
//     // setIsRequested(true);
//     const values = [...requestedReference];
//     values.splice(index, 1);
//     setRequestedReference(values);
//     if (sendReference.length > 0) {
//       handleCancelFormChange();
//     }
//     setSendReference([row]);
//   };

//   //Decline Reference Request
//   const handleDeclineReferenceRequest = (index, row) => {
//     setSendReference([row]);
//     const values = [...sendReference];
//     values[0].references[0]["is_email"] = false;
//     values[0].references[0]["is_accept"] = false;
//     values[0].references[0]["referees_id"] = null;
//     values[0].references[0]["referees_name"] = null;
//     values[0].references[0]["referees_email"] = null;
//     const updateReferenceStatus = values[0].references[0];
//     props.sendReferenceRequested(
//       updateReferenceStatus,
//       updateReferenceStatus.id,
//       values
//     );
//     setSendReference([]);
//   };

//   const handleRemoveFormChange = (index) => {
//     const values = [...requestedReference];
//     const a = values.splice(index, 1);
//     setRequestedReference(values);
//   };

//   const handleChangeForm = (event) => {
//     const values = [...sendReference];
//     values[0].references[refId]["referees_reference"] = event.target.value;
//   };

//   const handlechangeForm = (event) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       [event.target.name]: event.target.value,
//     }));
//   };

//   const handleSubmitForm = (event) => {
//     event.preventDefault();
//     const values = [...sendReference];
//     values[0].references[refId]["is_accept"] = true;
//     values[0].references[refId]["referees_id"] = props?.profile?.id;
//     const updateReferenceStatus = values[0].references[refId];
//     props.sendReferenceRequested(
//       updateReferenceStatus,
//       updateReferenceStatus.id,
//       values
//     );
//     setSendReference([]);
//   };

//   const handleCancelFormChange = () => {
//     setRequestedReference((prevState) => [...prevState, sendReference[0]]);
//     setSendReference([]);
//   };

//   const [show, setShow] = useState(false);
//   const [emailData, setEmailData] = useState({ email: "" });
//   const handleClose = () => setShow(false);

//   const handleCancelReferenceForm = () => {
//     setIsRequested(false);
//     setFormData([]);
//   };

//   //Send Reference Request
//   const handleSubmitReferenceForm = async () => {
//     setIsRequested(false);
//     const excludedFields = [
//       "id",
//       "referees_reference",
//       "is_accept",
//       "is_email",
//       "sender",
//       "referees_id",
//     ];

//     let isEmpty = false;

//     for (const key in formData) {
//       if (
//         !excludedFields.includes(key) &&
//         (formData[key] === null || formData[key] === "")
//       ) {
//         isEmpty = true;
//         break;
//       }
//     }

//     if (isEmpty) {
//       alert("Please fill each column respectively");
//     } else {
//       try {
//         await props.updateUserReference(formData, formData.id);
//         setShouldRenderMyReferences(false);
//         setShouldRenderMyReferences(!shouldRenderMyReferences);
//         setFormData([]);
//         window.location.reload();
//       } catch (error) {
//         console.error("Error updating user reference:", error);
//       }
//     }

//     // try {
//     //   await props.updateUserReference(formData, formData.id);
//     //   setShouldRenderMyReferences(false);
//     //   setShouldRenderMyReferences(!shouldRenderMyReferences);
//     //   setFormData([]);
//     //   window.location.reload();
//     // } catch (error) {
//     //   console.error("Error updating user reference:", error);
//     // }
//   };

//   const handleSendReferenceForm = (index, row) => {
//     setIsRequested(true);
//     setFormData(row);
//     setEmailData({
//       email: row.referees_email,
//     });
//   };
//   //delete reference
//   const deleteReference = async (row) => {
//     try {
//       const response = await axiosInstance.delete(
//         `api/network/reference/${row?.id}`
//       );
//       setShouldRenderMyReferences(!shouldRenderMyReferences);
//       window.location.reload();
//     } catch (error) {
//       console.error("Error deleting reference:", error);
//     }
//   };

//   useEffect(() => {
//     setMyreferences(props.myReferences);
//     if (Object.keys(props.profile).length > 0) {
//       if (props.myReferences.length === 0 && data.is_myReferences === false) {
//         setData((prevState) => ({ ...prevState, is_myReferences: true }));
//         props.fetchMyReferences();
//       }

//       if (
//         props.requestedReferences.length === 0 &&
//         data.is_requested_references === false
//       ) {
//         setData((prevState) => ({
//           ...prevState,
//           is_requested_references: true,
//         }));
//         props.fetchRequestedReferences(props.profile.id);
//       }

//       if (props.requestedReferences) {
//         setRequestedReference(props.requestedReferences);
//       }
//     }
//     // props?.fetchMyReferences();
//     // props?.fetchRequestedReferences(props?.profile.id);
//     setShouldRenderMyReferences(true);
//   }, [props, shouldRenderMyReferences]);
//   return (
//     <div>
//       <div className="row connection-request-section"></div>
//       <Collapse in={requestModel}>
//         <div className="row ">
//           {sendReference &&
//             sendReference.map((row, index) => {
//               return (
//                 <form key={row.id}>
//                   <div className="col-12 card-block">
//                     <div className="card-border">
//                       <div className="row Reference">
//                         <div className="col-12 mb-4">
//                           <textarea
//                             name="reference_request"
//                             className="form-control mb-215"
//                             placeholder="Referees Reference"
//                             defaultvalue={
//                               row.references[refId].referees_reference
//                             }
//                             onChange={(event) => handleChangeForm(event)}
//                           ></textarea>
//                         </div>
//                         <div className="col-12 mb-4">
//                           <div className="row">
//                             <div className="col-md-6 col-12">
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Refereed Name"
//                                 name="username"
//                                 value={row.userId.username}
//                                 disabled
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-12 mb-4">
//                           <textarea
//                             type="text"
//                             className="form-control mh-215"
//                             placeholder="Reference Request"
//                             name="reference_request"
//                             value={row.references[refId].reference_request}
//                             disabled
//                           />
//                         </div>
//                         <div className="col-12 mb-4">
//                           <div className="row">
//                             <div className="col-md-6 col-12">
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Title"
//                                 namme="title"
//                                 value={row.references[refId].title}
//                                 disabled
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-12 mb-4 text-right">
//                           <Button
//                             variant="info"
//                             onClick={handleCancelFormChange}
//                             className="contact-btn"
//                           >
//                             Cancel
//                           </Button>{" "}
//                           &nbsp;
//                           <Button
//                             variant="info"
//                             type="submit"
//                             onClick={handleSubmitForm}
//                             className="contact-btn"
//                           >
//                             Send &gt;
//                           </Button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               );
//             })}
//         </div>
//       </Collapse>
//       <div className="row my-reference-section">
//         <div className="col-12">
//           <div className="row align-items-end mb-3">
//             <div className="col-md-6 col-12">
//               <h2 className="block-title">MY References</h2>
//             </div>
//             <div className="col-md-6 col-12 text-right">
//               {/* <h3 className="section-sub-title">REFERENCES - 50% COMPLETE</h3> */}
//             </div>
//           </div>
//         </div>
//         <div className="col-12 mb-3 border-box-title">
//           <h2
//             className="mb-0 reference-subtitle"
//             style={{ fontWeight: "700", color: "#283270" }}
//           >
//             Target to obtain four Professional References
//           </h2>
//         </div>
//         {myReferences?.length > 0 ? (
//           myReferences.map((row, index) => {
//             if (row.is_accept === true) {
//               return (
//                 <div className="col-md-6 col-12 mb-4">
//                   <div className="reference-block">
//                     <h2 className="reference-block-title">
//                       {row.title}
//                       {/* <span className="ni nicon-pen"></span> */}
//                       <button
//                         onClick={() => deleteReference(row)}
//                         style={{ fontSize: "16px" }}
//                       >
//                         Delete
//                       </button>
//                     </h2>
//                     <div className="reference-block-content">
//                       {row.referees_reference.length > 82 ? (
//                         <div>
//                           {showFullText[index] ? (
//                             <p>{row.referees_reference}</p>
//                           ) : (
//                             <p>{row.referees_reference.slice(0, 82)}...</p>
//                           )}
//                           <button
//                             onClick={() => toggleText(index)}
//                             style={{ fontSize: "12px", color: "#283270" }}
//                           >
//                             {showFullText[index] ? "Show Less" : "Show More.."}
//                           </button>
//                         </div>
//                       ) : (
//                         <p>{row.referees_reference}</p>
//                       )}
//                     </div>
//                     <div className="reference-block-footer">
//                       <div className="hexagon-wrap">
//                         <HexaImage
//                           image={IMAGEAPI + row.referees_id.profile_pic}
//                         />
//                       </div>
//                       <div className="reference-block-footer-content">
//                         <div className="left-block">
//                           <div className="name">
//                             {row.referees_id.userId.username}
//                           </div>
//                           <div className="designation">
//                             {row.referees_id.primary_job_title}
//                           </div>
//                           <div className="company">
//                             {row.referees_id.company_name}
//                           </div>
//                         </div>
//                         {/* <div className="right-block">
//                           <span className="mailto">
//                             <img
//                               alt=""
//                               src="/assets/images/icons/envelopes.svg"
//                             />
//                           </span>
//                         </div> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             } else {
//               return (
//                 <div className="col-md-6 col-12 mb-4">
//                   <div className="reference-search-block reference-waiting">
//                     <h2 className="reference-search-block-title">
//                       {row.title !== null
//                         ? row.title
//                         : `Reference ${index + 1}`}

//                       {/* <Link
//                                                 to=""
//                                                 data-target=".multi-collapse"
//                                                 aria-controls="collapseExample"
//                                                 aria-expanded={isRequested}
//                                                 onClick={() => handleSendReferenceForm(index, row)}
//                                             >
//                                                 <span className="ni nicon-pen"></span>
//                                             </Link> */}
//                     </h2>
//                     <div className="reference-search-block-content">
//                       {row.reference_request !== null ? (
//                         <p>
//                           {row.reference_request.length > 82 ? (
//                             <div>
//                               {showRequestFullText[index] ? (
//                                 <p>{row.reference_request}</p>
//                               ) : (
//                                 <p>{row.reference_request.slice(0, 82)}...</p>
//                               )}
//                               <button
//                                 onClick={() => toggleRequestText(index)}
//                                 style={{ fontSize: "12px", color: "#283270" }}
//                               >
//                                 {showRequestFullText[index]
//                                   ? "Show Less"
//                                   : "Show More.."}
//                               </button>
//                             </div>
//                           ) : (
//                             <p>{row.reference_request}</p>
//                           )}
//                         </p>
//                       ) : (
//                         <>
//                           <p>
//                             We recommend you have a minimum of 4 references.
//                             <br />
//                             <br />
//                             Search your goneet contacts or invite referee to
//                             join our network
//                           </p>
//                           {/* <p>
//                             Search your neet contacts or ask Link referee to
//                             join our network
//                           </p> */}
//                         </>
//                       )}
//                     </div>
//                     <div className="reference-search-block-footer">
//                       <div className="hexagon-wrap">
//                         <HexaImage image={"/assets/images/Reach_out.jpg"} />
//                       </div>
//                       <div className="reference-search-block-footer-content">
//                         <h2
//                           className="reference-search-block-title"
//                           style={{ fontSize: "20px" }}
//                         >
//                           <Link
//                             to=""
//                             data-target=".multi-collapse"
//                             aria-controls="collapseExample"
//                             aria-expanded={isRequested}
//                             onClick={() => handleSendReferenceForm(index, row)}
//                           >
//                             {/* <span className="ni nicon-pen"></span> */}
//                             {row.reference_request !== null ? (
//                               <span>Requested</span>
//                             ) : (
//                               <span>Request</span>
//                             )}
//                           </Link>
//                         </h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             }
//           })
//         ) : (
//           <label style={{ textAlign: "center" }}>Loading...</label>
//         )}
//       </div>

//       <Collapse in={isRequested}>
//         <div className="row margin-row" id="collapseExample">
//           <div className="col-12 card-block">
//             <div className="card-border">
//               <div className="row Reference">
//                 <div className="col-12 mb-4">
//                   <small style={{ fontSize: "14px" }}>Reference</small>
//                   <textarea
//                     name="reference_request"
//                     className="form-control mh-215"
//                     // placeholder="Reference"
//                     onChange={(event) => handlechangeForm(event)}
//                     value={formData.reference_request}
//                   ></textarea>
//                 </div>
//                 <div className="col-12 mb-4">
//                   <div className="row">
//                     <div className="col-md-6 col-12">
//                       <small style={{ fontSize: "14px" }}>Referees Name</small>
//                       <input
//                         type="text"
//                         name="referees_name"
//                         className="form-control"
//                         // placeholder="Referees Name"
//                         onChange={(event) => handlechangeForm(event)}
//                         value={formData.referees_name}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 mb-4">
//                   <div className="row">
//                     <div className="col-md-6 col-12">
//                       <small style={{ fontSize: "14px" }}>Referees email</small>
//                       <input
//                         type="email"
//                         name="referees_email"
//                         className="form-control"
//                         // placeholder="Referees email"
//                         onChange={(event) => handlechangeForm(event)}
//                         value={formData.referees_email}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 mb-4">
//                   <div className="row">
//                     <div className="col-md-6 col-12">
//                       <small style={{ fontSize: "14px" }}>Title</small>
//                       <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         maxLength="50"
//                         // placeholder="Title"
//                         onChange={(event) => handlechangeForm(event)}
//                         value={formData.title}
//                       />
//                       <small style={{ color: "gray" }}>
//                         Max characters: 50
//                       </small>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 mb-4 text-right">
//                   <Button
//                     variant="info"
//                     onClick={handleCancelReferenceForm}
//                     className="contact-btn"
//                   >
//                     Cancel
//                   </Button>
//                   &nbsp;
//                   <Button
//                     variant="info"
//                     type="submit"
//                     onClick={(event) => handleSubmitReferenceForm(event)}
//                     className="contact-btn"
//                   >
//                     Send Request &gt;
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Collapse>
//       <div className="col-12" style={{ paddingLeft: "0px" }}>
//         <h2 className="block-title">Requested References</h2>
//         {/* <h2 className="section-title">Requested References</h2> */}
//         <div className="border-box">
//           <div className="row small-gutter">
//             <div className="col-12">
//               <div className="border-box-title">
//                 <label>Waiting Your Response</label>
//                 {/* <a href="#" className="more-btn">
//                                         {"more"}
//                                     </a> */}
//               </div>
//             </div>
//             {requestedReference.length > 0 ? (
//               requestedReference.map((row, index) => {
//                 return (
//                   <div className="col-sm-6 col-12 cmb-12" key={index}>
//                     <div
//                       className="connect-profile"
//                       style={{ display: "flex", alignItems: "center" }}
//                     >
//                       <div className="profile-thumb">
//                         <div className="hexagon-wrap">
//                           <HexaImage
//                             image={
//                               row.profile_pic !== null
//                                 ? IMAGEAPI + row.profile_pic
//                                 : "/assets/images/no-profile.png"
//                             }
//                           />
//                         </div>
//                       </div>
//                       <div className="profile-content">
//                         <div className="left-content">
//                           <div className="name">{row.userId.username}</div>
//                           <div className="designition">
//                             {row.primary_job_title}
//                           </div>
//                           <div className="mutual-connection">
//                             {row.mutual_connections} mutual connections
//                           </div>
//                         </div>
//                       </div>
//                       <div style={{ marginLeft: "auto" }}>
//                         <div className="right-content-pending-requests">
//                           <button
//                             data-target=".multi-collapse"
//                             aria-controls="collapseExample"
//                             aria-expanded={isRequested}
//                             onClick={() =>
//                               handleRequestedReferenceFormChange(index, row)
//                             }
//                             className="connect-profile-link"
//                             style={{ color: "#15438F" }}
//                           >
//                             <b>Accept</b>
//                           </button>
//                         </div>
//                         &nbsp;
//                         <div className="right-content-pending-requests">
//                           <button
//                             onClick={() =>
//                               handleDeclineReferenceRequest(index, row)
//                             }
//                             className="connect-profile-link "
//                             style={{ color: "#15438F" }}
//                           >
//                             <b>Decline</b>
//                           </button>
//                         </div>
//                       </div>
//                       <Link
//                         to=""
//                         onClick={() => handleRemoveFormChange(index)}
//                         className="remove-block"
//                       >
//                         x
//                       </Link>
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <label style={{ textAlign: "center", paddingLeft:"20px"}}>
//                 You have no requested references
//               </label>
//             )}
//           </div>
//         </div>
//       </div>

//       <Modal show={show} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Modal heading</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
//         <Modal.Footer>
//           <Link variant="secondary" onClick={handleClose}>
//             Close
//           </Link>
//           <Link variant="primary" onClick={handleClose}>
//             Save Changes
//           </Link>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;
//   const profile = state.user.profile;
//   const myReferences = state.network.myReferences;
//   const requestedReferences = state.network.requestedReferences;

//   return {
//     user: user,
//     profile: profile,
//     myReferences: myReferences,
//     requestedReferences: requestedReferences,
//   };
// };

// const mapDispatchToProps = (dispatch, state) => {
//   return {
//     fetchMyReferences: () => dispatch(fetchMyReferencesAction()),
//     fetchRequestedReferences: (profileId) =>
//       dispatch(fetchRequestedReferenceAction(profileId)),
//     sendReferenceRequested: (updateReference, id, values) =>
//       dispatch(sendReferenceRequestedAction(updateReference, id, values)),

//     updateUserReference: (formData, id) =>
//       dispatch(updateUserReferenceAction(formData, id)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(References);
















import React, { useState, useEffect } from "react";
import { Button, Collapse, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../BackendConnections";
import {
  fetchMyReferencesAction,
  fetchRequestedReferenceAction,
  sendReferenceRequestedAction,
  updateUserReferenceAction,
  deleteReferenceRequestAction,
} from "../../redux/actions/network/networkAction";
import HexaImage from "../utils/imgCards/HexaImage";
import axiosInstance from "../authentication/helper/axiosApi";

export const References = (props) => {
  console.log(props);
  const [refId, setRefId] = useState(null);
  const [data, setData] = useState({
    is_myReferences: false,
    is_requested_references: false,
  });

  const [mailSent, setMailSent] = useState(false);
  const [isRequested, setIsRequested] = useState(false);
  const [requestedReference, setRequestedReference] = useState([]);
  const [sendReference, setSendReference] = useState([]);
  const [requestModel, setRequestModel] = useState(false);
  const [formData, setFormData] = useState([]);
  const [myReferences, setMyreferences] = useState();
  const [shouldRenderMyReferences, setShouldRenderMyReferences] =
    useState(true);
  const [showFullText, setShowFullText] = useState([]);
  const [showRequestFullText, setShowRequestFullText] = useState([]);
  const toggleText = (index) => {
    setShowFullText((prev) => {
      const newShowRequestFullText = [...prev];
      newShowRequestFullText[index] = !prev[index];
      return newShowRequestFullText;
    });
  };
  const toggleRequestText = (index) => {
    setShowRequestFullText((prev) => {
      const newShowRequestFullText = [...prev];
      newShowRequestFullText[index] = !prev[index];
      return newShowRequestFullText;
    });
  };

  //Accept Refrence
  const handleRequestedReferenceFormChange = (index, row) => {
    const uniqReferenceId = row?.references.findIndex((row) => {
      return row.referees_email === props?.user?.email;
    });
    setRefId(uniqReferenceId);
    setRequestModel(true);
    // setIsRequested(true);
    const values = [...requestedReference];
    values.splice(index, 1);
    setRequestedReference(values);
    if (sendReference.length > 0) {
      handleCancelFormChange();
    }
    setSendReference([row]);
  };

  //Decline Reference Request
  // const handleDeclineReferenceRequest = (index, row) => {
  //   setSendReference([row]);
  //   const values = [...sendReference];
  //   values[0].references[0]["is_email"] = false;
  //   values[0].references[0]["is_accept"] = false;
  //   values[0].references[0]["referees_id"] = null;
  //   values[0].references[0]["referees_name"] = null;
  //   values[0].references[0]["referees_email"] = null;
  //   const updateReferenceStatus = values[0].references[0];
  //   props.sendReferenceRequested(
  //     updateReferenceStatus,
  //     updateReferenceStatus.id,
  //     values
  //   );
  //   setSendReference([]);
  // };





// Decline Reference Request - simplified version
const handleDeclineReferenceRequest = async (index, row) => {
  const reference = row.references[0]; // or find the correct reference based on your logic
  const referenceId = reference.id;
  // console.log('----------refeEmail ',reference.referees_email)
  // console.log('-____---------------->Ref ',referenceId);
  

  
  try {
    await props.deleteReferenceRequest(referenceId);
    
    
    // Remove the declined reference from UI state
    const updatedReferences = [...requestedReference];
    updatedReferences.splice(index, 1);
    setRequestedReference(updatedReferences);
    
  } catch (error) {
    console.error("Failed to decline reference:", error);
    // Optionally show error message to user
  }
};

//////////////////////////////////////////////////
  const handleRemoveFormChange = (index) => {
    const values = [...requestedReference];
    const a = values.splice(index, 1);
    setRequestedReference(values);
  };

  const handleChangeForm = (event) => {
    const values = [...sendReference];
    values[0].references[refId]["referees_reference"] = event.target.value;
  };

  const handlechangeForm = (event) => {
  const { name, value } = event.target;

  if (name === "referees_email") {
    const enteredEmail = value.trim().toLowerCase();

    // Collect all other referees' emails from myReferences (excluding current reference)
    const usedEmails = props.myReferences
      .filter(ref => ref.referees_email && ref.id !== formData.id)
      .map(ref => ref.referees_email.trim().toLowerCase());

    if (usedEmails.includes(enteredEmail)) {
      alert("This email is already used in another reference.");
      return; // Prevent setting duplicate email
    }
  }

  setFormData((prevState) => ({
    ...prevState,
    [name]: value,
  }));
};

  const handleSubmitForm = (event) => {
    event.preventDefault();
    const values = [...sendReference];
    values[0].references[refId]["is_accept"] = true;
    values[0].references[refId]["referees_id"] = props?.profile?.id;
    const updateReferenceStatus = values[0].references[refId];
    props.sendReferenceRequested(
      updateReferenceStatus,
      updateReferenceStatus.id,
      values
    );
    setSendReference([]);
  };

  const handleCancelFormChange = () => {
    setRequestedReference((prevState) => [...prevState, sendReference[0]]);
    setSendReference([]);
  };

  const [show, setShow] = useState(false);
  const [emailData, setEmailData] = useState({ email: "" });
  const handleClose = () => setShow(false);

  const handleCancelReferenceForm = () => {
    setIsRequested(false);
    setFormData([]);
  };

  //Send Reference Request
  const handleSubmitReferenceForm = async () => {
    setIsRequested(false);
    const excludedFields = [
      "id",
      "referees_reference",
      "is_accept",
      "is_email",
      "sender",
      "referees_id",
      "title"
    ];
    console.log("formData", formData);
    console.log("excludedFields", excludedFields);
    let isEmpty = false;

    for (const key in formData) {
      if (
        !excludedFields.includes(key) &&
        (formData[key] === null || formData[key] === "")
      ) {
        isEmpty = true;
        break;
      }
    }

    if (isEmpty) {
      alert("Please fill each column respectively");
    } else {
      try {
        await props.updateUserReference(formData, formData.id);
        setShouldRenderMyReferences(false);
        setShouldRenderMyReferences(!shouldRenderMyReferences);
        setFormData([]);
        window.location.reload();
      } catch (error) {
        console.error("Error updating user reference:", error);
      }
    }

    // try {
    //   await props.updateUserReference(formData, formData.id);
    //   setShouldRenderMyReferences(false);
    //   setShouldRenderMyReferences(!shouldRenderMyReferences);
    //   setFormData([]);
    //   window.location.reload();
    // } catch (error) {
    //   console.error("Error updating user reference:", error);
    // }
  };

  const handleSendReferenceForm = (index, row) => {
    console.log("row", row);
    setIsRequested(true);
    setFormData(row);
    setEmailData({
      email: row.referees_email,
    });
  };
  //delete reference
  const deleteReference = async (row) => {
    try {
      const response = await axiosInstance.delete(
        `api/network/reference/${row?.id}/`
      );
      setShouldRenderMyReferences(!shouldRenderMyReferences);
      window.location.reload();
    } catch (error) {
      console.error("Error deleting reference:", error);
    }
  };

  useEffect(() => {
    setMyreferences(props.myReferences);
    if (Object.keys(props.profile).length > 0) {
      if (props.myReferences.length === 0 && data.is_myReferences === false) {
        setData((prevState) => ({ ...prevState, is_myReferences: true }));
        props.fetchMyReferences();
      }

      if (
        props.requestedReferences.length === 0 &&
        data.is_requested_references === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_requested_references: true,
        }));
        props.fetchRequestedReferences(props.profile.id);
      }

      if (props.requestedReferences) {
        setRequestedReference(props.requestedReferences);
      }
    }
    // props?.fetchMyReferences();
    // props?.fetchRequestedReferences(props?.profile.id);
    setShouldRenderMyReferences(true);
  }, [props, shouldRenderMyReferences]);
  return (
    <div>
      <div className="row connection-request-section"></div>
      <Collapse in={requestModel}>
        <div className="row ">
          {sendReference &&
            sendReference.map((row, index) => {
              return (
                <form key={row.id}>
                  <div className="col-12 card-block">
                    <div className="card-border">
                      <div className="row Reference">
                        <div className="col-12 mb-4">
                          <textarea
                            name="reference_request"
                            className="form-control mb-215"
                            placeholder="Referees Reference"
                            defaultvalue={
                              row.references[refId].referees_reference
                            }
                            onChange={(event) => handleChangeForm(event)}
                          ></textarea>
                        </div>
                        <div className="col-12 mb-4">
                          <div className="row">
                            <div className="col-md-6 col-12">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Refereed Name"
                                name="username"
                                value={row.userId.username}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 mb-4">
                          <textarea
                            type="text"
                            className="form-control mh-215"
                            placeholder="Reference Request"
                            name="reference_request"
                            value={row.references[refId].reference_request}
                            disabled
                          />
                        </div>
                        {/* <div className="col-12 mb-4">
                          <div className="row">
                            <div className="col-md-6 col-12">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Title"
                                namme="title"
                                value={row.references[refId].title}
                                disabled
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 mb-4 text-right">
                          <Button
                            variant="info"
                            onClick={handleCancelFormChange}
                            className="contact-btn"
                          >
                            Cancel
                          </Button>{" "}
                          &nbsp;
                          <Button
                            variant="info"
                            type="submit"
                            onClick={handleSubmitForm}
                            className="contact-btn"
                          >
                            Send &gt;
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              );
            })}
        </div>
      </Collapse>
      <div className="row my-reference-section">
        <div className="col-12">
          <div className="row align-items-end mb-3">
            <div className="col-md-6 col-12">
              <h2 className="block-title">MY References</h2>
            </div>
            <div className="col-md-6 col-12 text-right">
              {/* <h3 className="section-sub-title">REFERENCES - 50% COMPLETE</h3> */}
            </div>
          </div>
        </div>
        <div className="col-12 mb-3 border-box-title">
          <h2
            className="mb-0 reference-subtitle"
            style={{ fontWeight: "700", color: "#283270" }}
          >
            Target to obtain four Professional References
          </h2>
        </div>
        {myReferences?.length > 0 ? (
          myReferences.map((row, index) => {
            if (row.is_accept === true) {
              return (
                <div className="col-md-6 col-12 mb-4">
                  <div className="reference-block">
                    <h2 className="reference-block-title">
                      {row.title}
                      {/* <span className="ni nicon-pen"></span> */}
                      <button
                        onClick={() => deleteReference(row)}
                        style={{ fontSize: "16px" }}
                      >
                        Delete
                      </button>
                    </h2>
                    <div className="reference-block-content">
                      {row.referees_reference.length > 82 ? (
                        <div>
                          {showFullText[index] ? (
                            <p>{row.referees_reference}</p>
                          ) : (
                            <p>{row.referees_reference.slice(0, 82)}...</p>
                          )}
                          <button
                            onClick={() => toggleText(index)}
                            style={{ fontSize: "12px", color: "#283270" }}
                          >
                            {showFullText[index] ? "Show Less" : "Show More.."}
                          </button>
                        </div>
                      ) : (
                        <p>{row.referees_reference}</p>
                      )}
                    </div>
                    <div className="reference-block-footer">
                      <div className="hexagon-wrap">
                        <HexaImage
                          image={IMAGEAPI + row.referees_id.profile_pic}
                          
                        />
                      </div>
                      <div className="reference-block-footer-content">
                        <div className="left-block">
                          <div className="name">
                            {row.referees_id.userId.username}
                          </div>
                          <div className="designation">
                            {row.referees_id.primary_job_title}
                          </div>
                          <div className="company">
                            {row.referees_id.company_name}
                          </div>
                        </div>
                        {/* <div className="right-block">
                          <span className="mailto">
                            <img
                              alt=""
                              src="/assets/images/icons/envelopes.svg"
                            />
                          </span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="col-md-6 col-12 mb-4">
                  <div className="reference-search-block reference-waiting">
                    {/* <h2 className="reference-search-block-title">
                      {row.title !== null
                        ? row.title
                        : `Reference ${index + 1}`}

                        </h2> */}

                    {row.referees_name && (
                      <h4
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#454849",
                          marginTop: "4px",
                        }}
                      >
                        Referees Name: {row.referees_name}
                      </h4>
                    )}

                    {row.referees_email && (
                      <h4
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "#454849",
                          marginTop: "2px",
                        }}
                      >
                        <span>Referees Email: </span>
                        {row.referees_email}
                      </h4>
                    )}

                    {row.reference_request !== null ? (
                      <div>
                        <p>
                          <span>Subject: </span>
                          {row.reference_request.length > 82 ? (
                            showRequestFullText[index] ? (
                              <>
                                {row.reference_request}
                                <br />
                                <button
                                  onClick={() => toggleRequestText(index)}
                                  style={{ fontSize: "16px", color: "#283270" }}
                                >
                                  Show Less
                                </button>
                              </>
                            ) : (
                              <>
                                {row.reference_request.slice(0, 82)}...
                                <br />
                                <button
                                  onClick={() => toggleRequestText(index)}
                                  style={{ fontSize: "16px", color: "#283270" }}
                                >
                                  Show More..
                                </button>
                              </>
                            )
                          ) : (
                            row.reference_request
                          )}
                        </p>
                      </div>
                    ) : (
                      <>
                        <p>
                          We recommend you have a minimum of 4 references.
                          <br />
                          <br />
                          Search your goneet contacts or invite referee to join
                          our network
                        </p>
                      </>
                    )}

                    {/* <Link
                                                to=""
                                                data-target=".multi-collapse"
                                                aria-controls="collapseExample"
                                                aria-expanded={isRequested}
                                                onClick={() => handleSendReferenceForm(index, row)}
                                            >
                                                <span className="ni nicon-pen"></span>
                                            </Link> */}

                    <div className="reference-search-block-content"></div>
                    <div className="reference-search-block-footer">
                      <div className="hexagon-wrap">
                        {/* <div style={{ textAlign: "center", marginBottom: "10px" }}>
    <Link
      to=""
      data-target=".multi-collapse"
      aria-controls="collapseExample"
      aria-expanded={isRequested}
      onClick={() => handleSendReferenceForm(index, row)}
      style={{ textDecoration: "underline", color: "black", cursor: "pointer" }}
    >
      View/Edit
    </Link>
  </div> */}

                        <HexaImage image={"/assets/images/Reach_out.jpg"} />
                      </div>

                      <div className="reference-search-block-footer-content">
                        <h2
                          className="reference-search-block-title"
                          style={{ fontSize: "20px" }}
                        >
                          <Link
                            to=""
                            data-target=".multi-collapse"
                            aria-controls="collapseExample"
                            aria-expanded={isRequested}
                            onClick={() => handleSendReferenceForm(index, row)}
                          >
                            {row.reference_request !== null ? (
                              <span
                                style={{
                                  fontSize: "13px",
                                  color: "#454849",
                                  fontWeight: "500",
                                }}
                              >
                                View/Edit
                              </span>
                            ) : (
                              <span>Request</span>
                            )}
                          </Link>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          })
        ) : (
          <label style={{ textAlign: "center" }}>Loading...</label>
        )}
      </div>

      <Collapse in={isRequested}>
        <div className="row margin-row" id="collapseExample">
          <div className="col-12 card-block">
            <div className="card-border">
              <div className="row Reference">
                <div className="col-12 mb-4">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <small style={{ fontSize: "14px" }}>Referees Name</small>
                      <input
                        type="text"
                        name="referees_name"
                        className="form-control"
                        // placeholder="Referees Name"
                        onChange={(event) => handlechangeForm(event)}
                        value={formData.referees_name}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-4">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <small style={{ fontSize: "14px" }}>Referees email</small>
                      <input
                        type="email"
                        name="referees_email"
                        className="form-control"
                        // placeholder="Referees email"
                        onChange={(event) => handlechangeForm(event)}
                        value={formData.referees_email}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-12 mb-4">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <small style={{ fontSize: "14px" }}>Title</small>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        maxLength="50"
                        // placeholder="Title"
                        onChange={(event) => handlechangeForm(event)}
                        value={formData.title}
                      />
                      <small style={{ color: "gray" }}>
                        Max characters: 50
                      </small>
                    </div>
                  </div>
                </div> */}
                <div className="col-12 mb-4">
                  <small style={{ fontSize: "14px" }}>Subject</small>
                  <textarea
                    name="reference_request"
                    className="form-control mh-215"
                    // placeholder="Reference"
                    onChange={(event) => handlechangeForm(event)}
                    value={formData.reference_request}
                  ></textarea>
                </div>

                <div className="col-12 mb-4 text-right">
                  <Button
                    variant="info"
                    onClick={handleCancelReferenceForm}
                    className="contact-btn"
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    variant="info"
                    type="submit"
                    onClick={(event) => handleSubmitReferenceForm(event)}
                    className="contact-btn"
                  >
                    Send Request &gt;
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
      <div className="col-12" style={{ paddingLeft: "0px" }}>
        <h2 className="block-title">Requested References</h2>
        {/* <h2 className="section-title">Requested References</h2> */}
        <div className="border-box">
          <div className="row small-gutter">
            <div className="col-12">
              <div className="border-box-title">
                <label>Waiting Your Response</label>
                {/* <a href="#" className="more-btn">
                                        {"more"}
                                    </a> */}
              </div>
            </div>
            
            {requestedReference.length > 0 ? (
              requestedReference.map((row, index) => {
                 console.log('Requested Reference Row:',row);
                return (
                  <div className="col-sm-6 col-12 cmb-12" key={index}>
                    <div
                      className="connect-profile"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                     <div className="profile-thumb">
  <div className="hexagon-wrap">
    <HexaImage
      image={
        row.profile_pic 
          ? row.profile_pic 
          : "/assets/images/no-profile.png"
      }
      onError={(e) => {
        e.target.onerror = null; 
        e.target.src = "/assets/images/no-profile.png";
      }}
    />
  </div>
</div>
                      <div className="profile-content">
                        <div className="left-content">
                          <div className="name">{row.userId.username}</div>
                          <div className="designition">
                            {row.primary_job_title}
                          </div>
                          <div className="mutual-connection">
                            {row.mutual_connections} mutual connections
                          </div>
                        </div>
                      </div>
                      <div style={{ marginLeft: "auto" }}>
                        <div className="right-content-pending-requests">
                          <button
                            data-target=".multi-collapse"
                            aria-controls="collapseExample"
                            aria-expanded={isRequested}
                            onClick={() =>
                              handleRequestedReferenceFormChange(index, row)
                            }
                            className="connect-profile-link"
                            style={{ color: "#15438F" }}
                          >
                            <b>Accept</b>
                          </button>
                        </div>
                        &nbsp;
                        <div className="right-content-pending-requests">
                          <button
                            onClick={() =>
                              handleDeclineReferenceRequest(index, row)
                            }
                            className="connect-profile-link "
                            style={{ color: "#15438F" }}
                          >
                            <b>Decline</b>
                          </button>
                        </div>
                      </div>
                      <Link
                        to=""
                        onClick={() => handleRemoveFormChange(index)}
                        className="remove-block"
                      >
                        x
                      </Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <label style={{ textAlign: "center", paddingLeft: "20px" }}>
                You have no requested references
              </label>
            )}
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Link variant="secondary" onClick={handleClose}>
            Close
          </Link>
          <Link variant="primary" onClick={handleClose}>
            Save Changes
          </Link>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const myReferences = state.network.myReferences;
  const requestedReferences = state.network.requestedReferences;

  return {
    user: user,
    profile: profile,
    myReferences: myReferences,
    requestedReferences: requestedReferences,
  };
};

// const mapDispatchToProps = (dispatch, state) => {
//   return {
//     fetchMyReferences: () => dispatch(fetchMyReferencesAction()),
//     fetchRequestedReferences: (profileId) =>
//       dispatch(fetchRequestedReferenceAction(profileId)),
//     sendReferenceRequested: (updateReference, id, values) =>
//       dispatch(sendReferenceRequestedAction(updateReference, id, values)),

//     updateUserReference: (formData, id) =>
//       dispatch(updateUserReferenceAction(formData, id)),
//   };
// };

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchMyReferences: () => dispatch(fetchMyReferencesAction()),
    fetchRequestedReferences: (profileId) =>
      dispatch(fetchRequestedReferenceAction(profileId)),
    sendReferenceRequested: (updateReference, id, values) =>
      dispatch(sendReferenceRequestedAction(updateReference, id, values)),
    deleteReferenceRequest: (referenceId) => 
      dispatch(deleteReferenceRequestAction(referenceId)),
    updateUserReference: (formData, id) =>
      dispatch(updateUserReferenceAction(formData, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(References);
